<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="''"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="banner_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../assets/img/sign-in/bnner_1.webp" />
					<div class="msg_box">
						<div class="title"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>My Profile</div>
						<div class="text"></div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--位置-->
			<div class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-icon name="wap-home" class="icon" color="#808080" size="20px" />
				<span @click="goHome" style="cursor: pointer;">Home</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span style="color: #808080;">Information</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						Edit information
					</div>
					<div class="right">
						<el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="160px" class="demo-ruleForm">
							<el-form-item label="First Name" prop="firstName">
								<el-input v-model="ruleForm.firstName" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Last Name" prop="lastName">
								<el-input v-model="ruleForm.lastName" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Organization Name" prop="organizationName">
								<el-input v-model="ruleForm.organizationName" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Street Address" prop="streetAdress">
								<el-input v-model="ruleForm.streetAdress" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="City" prop="city">
								<el-input v-model="ruleForm.city" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="State" prop="state">
								<el-input v-model="ruleForm.state" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Country" prop="country">
								<el-input v-model="ruleForm.country" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Zip Code" prop="zipCode">
								<el-input v-model="ruleForm.zipCode" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Email" prop="" style="position: relative;">
								<el-input disabled v-model="ruleForm.email" placeholder="Enter"></el-input>
								<span style="position: absolute;right: 0;color: #006BB3;top: 10px;font-size: 16px;right: -36px;cursor: pointer;text-decoration: underline;font-style: italic;" @click="goEditEmail">Edit</span>
							</el-form-item>
							<el-form-item label="Phone" prop="">
								<el-input v-model="ruleForm.phone" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Customer Number" prop="">
								<el-input v-model="ruleForm.customerNumber" placeholder="Enter"></el-input>
							</el-form-item>
						</el-form>
						<div class="btn_box">
							<van-button color="#E37542" class="btn_el" @click="saveEdit('ruleForm')">Save</van-button>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { editInfo, userInfo } from '@/api/public.js';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			ruleForm: {
				firstName: '',
				lastName: '',
				organizationName: '',
				streetAdress: '',
				city: '',
				state: '',
				country: '',
				zipCode: '',
				email: localStorage.getItem('email'),
				phone: '',
				customerNumber: ''
			},
			rules: {
				firstName: [
					{ required: true, message: 'Please enter your First Name', trigger: 'blur' }
				],
				lastName: [
					{ required: true, message: 'Please enter your Last Name', trigger: 'blur' }
				],
				organizationName: [
					{ required: true, message: 'Please enter your Organization Name', trigger: 'blur' }
				],
				streetAdress: [
					{ required: true, message: 'Please enter your Street Address', trigger: 'blur' }
				],
				city: [
					{ required: true, message: 'Please enter your City', trigger: 'blur' }
				],
				state: [
					{ required: true, message: 'Please enter your State', trigger: 'blur' }
				],
				country: [
					{ required: true, message: 'Please enter your Country', trigger: 'blur' }
				],
				zipCode: [
					{ required: true, message: 'Please enter your Zip Code', trigger: 'blur' }
				],
				email: [
					{ required: true, message: 'Please enter your Email', trigger: 'blur' }
				],
			},
			userToken: localStorage.getItem('userToken')
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.userToken) {
			userInfo().then(res => {
				that.ruleForm = {
					firstName: res.data.first_name,
					lastName: res.data.last_name,
					organizationName: res.data.organization_name,
					streetAdress: res.data.street_address,
					city: res.data.city,
					state: res.data.state,
					country: res.data.country,
					zipCode: res.data.zip_code,
					phone: res.data.mobile,
					email: res.data.email,
					customerNumber: res.data.customer_number
				},
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
		}
	},
	methods: {
		//点击确定
		saveEdit(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
					editInfo({
						first_name: that.ruleForm.firstName,
						last_name: that.ruleForm.lastName,
						organization_name: that.ruleForm.organizationName,
						street_address: that.ruleForm.streetAdress,
						city: that.ruleForm.city,
						state: that.ruleForm.state,
						zip_code: that.ruleForm.zipCode,
						country: that.ruleForm.country,
						mobile: that.ruleForm.phone,
						customer_number: that.ruleForm.customerNumber
					}).then(res => {
						that.$toast.clear();
						localStorage.setItem('firstName', that.ruleForm.firstName);
						that.$toast('Modified successfully');
						setTimeout(() => {
							window.location.reload();
						}, 1000);
					});
				}
			})
		},
		goEditEmail() {
			this.$router.push('/edit-email');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.block_1{
		padding: 60px 0;
		.block_1_main{
			width: 600px;
			margin: 0 auto;
			// display: flex;
			.right{
				// flex: 1.2;
				.btn_box{
					padding: 20px 0 0 160px;
					.btn_el{
						padding: 8px 30px 5px 30px;
						font-size: 20px;
						border-radius: 6px;
					}
				}
			}
			.left{
				// flex: 1;
				padding-bottom: 30px;
				text-align: center;
				font-size: 40px;
				color: #006BB3;
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
	//banner
	.banner_box{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		.banner_el{
			position: relative;
			.msg_box{
				width: 100%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				.text{
					font-size: 24px;
					color: #ffffff;
				}
				.title{
					font-size: 56px;
					color: #ffffff;
				}
			}
			img{
				width: 100%;
				min-width: 1140px;
			}
		}
	}
}
</style>
<style scoped>
>>> .el-form-item{
	margin-bottom: 15px;
}
>>> .el-form--label-top .el-form-item__label{
	padding-bottom: 0;
	color: #006BB3;
	font-size: 16px;
}
>>> .el-input__inner{
	height: 42px;
	font-size: 18px;
	border: 1px solid #CCCCCC;
}
</style>